import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询样板间列表
export const queryRooms: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setRooms', { ...state.list, loading: true });
    // const res: IPageData = await $http.post('/design/group/list/blankroom', payload);
    const res: IPageData = await $http.post('/v1/design/blankroom/list', payload);
    commit('setRooms', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setRooms', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询样板间详情
export const queryDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDetail', { data: null, loading: true });
    // const res = await $http.get(`/design/project/get/${payload}`);
    const res = await $http.get(`/v1/design/blankroom/${payload}/detail`);
    commit('setDetail', { data: res });
  } catch (e) {
    commit('setDetail', { data: null });
  }
};

// 编辑样板间
export const editRoom: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/design/project/modify', payload);
    await $http.post('/v1/design/blankroom/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除样板间
export const deleteRoom: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, visible: true, loading: true });
    await $http.post('/v1/design/blankroom/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 上传缩略图
export const uploadThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setRoomThumb', { ...state.thumb, loading: true });
    // const res = await $http.post('/design/group/file/upload/project/image', payload);
    const res = await $http.post('/v1/design/blankroom/uploadimage', payload);
    commit('setRoomThumb', { data: res, loading: false });
  } catch (e) {
    commit('setRoomThumb', { data: null, loading: false });
  }
};

// 查询定制物品
export const querySpecifics: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSpecifics', {  ...state.specifics, loading: true });
    // const res = await $http.post('/design/room/specificitem/list', payload);
    const res = await $http.post('/v1/design/blankroom/listforspecificitem', payload);
    commit('setSpecifics', { data: res || [] });
  } catch (e) {
    commit('setSpecifics', { data: [] });
  }
};

// 新增定制物品(批量)
export const addSpecific: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSpecificDialog', { ...state.specificDialog, loading: true });
    // await $http.post('/item/model/specificmap/batch/add', payload);
    await $http.post('/v1/design/blankroom/addspecificitem', payload);
  } finally {
    commit('setSpecificDialog', { visible: false });
  }
};

// 复制定制物品
export const copySpecific: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSpecificDialog', { ...state.specificDialog, loading: true });
    // await $http.post('/design/room/specificitem/copy', payload);
    await $http.post('/v1/design/blankroom/copyspecificitem', payload);
  } finally {
    commit('setSpecificDialog', { visible: false });
  }
};

// 删除定制物品
export const deleteSpecific: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/item/model/specificmap/batch/delete', payload);
    await $http.post('/v1/asset/item/chosenmap/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 查询清理日志
export const queryClearLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setClearLogs', { ...state.clearLogs, loading: true });
    // const res: IPageData = await $http.post('/blank/room/clear/data/log/list', payload);
    const res: IPageData = await $http.post('/v1/design/blankroom/clearlog', payload);
    commit('setClearLogs', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setClearLogs', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询失效的地图
export const queryInvalidRooms: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setInvalidRooms', { ...state.invalidRooms, loading: true });
    // const res = await $http.post('/blank/room/invalid/list', payload);
    const res = await $http.post('/v1/design/blankroom/invalidlist', payload);
    commit('setInvalidRooms', { data: res });
  } catch (e) {
    commit('setInvalidRooms', { data: [] });
  }
};

// 批量清理失效的地图
export const clearInvalidMap: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/blank/room/invalid/batch/delete', payload);
    await $http.post('/v1/design/blankroom/deleteinvalid', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 查询光照配置(功能已被隐藏)
export const queryEnvLight: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setEnvLight', { data: null, loading: true });
    const res = await $http.post('/v1/design/blankroom/scenelight', payload);
    commit('setEnvLight', { data: res });
  } catch (e) {
    commit('setEnvLight', { data: null });
  }
};

// 保存光照配置(功能已被隐藏)
export const saveEnvLight: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  await $http.post('/v1/design/blankroom/updatescenelight', payload);
  store.commit('common/setToast', { visible: true, text: '保存成功' });
};
